import validator from 'validator';

export const validateLogin = ({username, password, otp, showOTP}) => {
  const validationStatus = {};
  let valid = true;
  if (!username) {
    validationStatus['username'] = {
      status: 'error',
      help: 'Username is required',
    };
    valid = false;
  }
  if (username && !validator.isLength(username, {min: 3})) {
    validationStatus['username'] = {
      status: 'error',
      help: 'Username cannot be less than 3 characters',
    };
    valid = false;
  }
  if (!password) {
    validationStatus['password'] = {
      status: 'error',
      help: 'Password is required',
    };
    valid = false;
  }
  if (password && !validator.isLength(password, {min: 4})) {
    validationStatus['password'] = {
      status: 'error',
      help: 'Password cannot be less than 4 characters',
    };
    valid = false;
  }

  if (showOTP && !otp) {
    validationStatus['otp'] = {
      status: 'error',
      help: 'OTP is required',
    };
    valid = false;
  }
  if (
    showOTP &&
    otp &&
    (!validator.isNumeric(otp) || !validator.isLength(otp, {min: 6}))
  ) {
    validationStatus['otp'] = {
      status: 'error',
      help: 'Please enter valid otp',
    };
    valid = false;
  }

  return {valid, validationStatus};
};
